import React, { useCallback, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

import { endOfToday, startOfToday } from 'date-fns';

import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { useDescriptionContentUtils } from '@ecp/common/src/utils/useDescriptionContentUtils';
import { metaDescriptionContent, documentTitle } from '@ecp/common/src/const/htmlHeadMessage';

import { downloadFiles } from '@bo-utils/fileUtils';
import { dateFormatter } from '@bo-utils/formUtils';
import { useDashboardGridOptions } from '@bo-hooks/dashBoard/useDashboard';
import { getNotificationList } from '@bo-apis/customerService/notificationApi';
import commonApi from '@bo-apis/common/commonApi';
import DashboardContentBox from '@bo-components/dashBoard/DashboardContentBox';
import ManualDownloadCard from '@bo-components/dashBoard/ManualDownloadCard';
import Grid from '@bo-components/common/grid/Grid';
import NoticePopup from '@bo-components/dashBoard/NoticePopup';
import WelmallLogo from '@bo-assets/image/common/image__ci_logo.png';

const MainPage = () => {
  const [content, setContent] = useState([]);
  const [total, setTotal] = useState(0);
  const [showNoticePopup, setShowNoticePopup] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState('');

  /*BO html head meta description content*/
  useDescriptionContentUtils(metaDescriptionContent.boContent);
  useLayoutEffect(() => {
    document.title = documentTitle.boTitle;
  }, []);

  const { gridOptions } = useDashboardGridOptions();

  const handleSearch = useCallback(
    async (pageIndex, pageSize, sort = {}) => {
      const params = {
        boNotificationYn: 'Y',
        poNotificationYn: 'N',
        foNotificationYn: 'N',
        coNotificationYn: 'N',
        displayYn: 'Y',
        notificationDivision: ['0', '1', '2', '3'],
        fromDateTime: dateFormatter(startOfToday()),
        toDateTime: dateFormatter(endOfToday()),
        siteNumber: '',
        title: '',
      };
      const { result } = await getNotificationList({
        form: params,
        pageable: { size: pageSize, page: pageIndex, sort },
      });
      setContent(result.content);
      setTotal(result.totalElements);
    },
    [setContent]
  );

  const handleClickDownload = async (id) => {
    const { result } = await commonApi.getFileByFileId(id);
    await downloadFiles(result);
  };

  const handleRowClick = useCallback(
    ({ row }) => {
      if (row?.Kind !== 'Header') {
        setShowNoticePopup(true);
        setSelectedNotice(row.notificationSeq.toString());
      }
    },
    [setShowNoticePopup]
  );

  return (
    <>
      <Container>
        <img src={WelmallLogo} alt={'logo'} />
        <Spacing bottom={12} />
        <TextBox font-weight={'700'} font-size={24}>
          Dashboard
        </TextBox>
        <Spacing bottom={60} />
        <FlexBox>
          <DashboardContentBox title={'공지사항'} width={'728px'} bodyHeight={'610px'}>
            <Grid
              unPaged
              readOnly
              title={'공지사항'}
              total={total}
              data={content}
              options={gridOptions}
              onSearch={handleSearch}
              onClick={handleRowClick}
              height={'500px'}
            />
          </DashboardContentBox>
          <Spacing left={16} />
          <DashboardContentBox title={'매뉴얼 다운로드'} width={'356px'} bodyHeight={'610px'}>
            <ManualDownloadCard label={'BO 매뉴얼'} onClick={() => handleClickDownload('bo_manual_file')} />
            <ManualDownloadCard
              label={'상품일괄등록 가이드'}
              onClick={() => handleClickDownload('good_regist_manual_file')}
            />
            <ManualDownloadCard
              label={'가격정보엑셀업로드 가이드'}
              onClick={() => handleClickDownload('price_info_manual_file')}
            />
            <ManualDownloadCard
              label={'옵션정보엑셀 가이드'}
              onClick={() => handleClickDownload('option_info_manual_file')}
            />
          </DashboardContentBox>
        </FlexBox>
      </Container>
      <NoticePopup
        isBO={true}
        open={showNoticePopup}
        onClose={() => setShowNoticePopup(false)}
        noticeSeq={selectedNotice}
      />
    </>
  );
};

export default MainPage;

const Container = styled(FlexBoxColumn)`
  padding: 44px 30px 0;
  align-items: flex-start;
`;
